export default __webpack_public_path__ + "static/media/loader.fb21381d.svg?v=elephant-20261103";